// extracted by mini-css-extract-plugin
module.exports = {"navigationLink":"styles_navigationLink__z5uYK","headerLink":"styles_headerLink__sT1MN"};